import React from "react";
import "../../../../css/Common/Components/Cards/CardServicesAdvisers.css";
import "../../../../css/App.css";
import { useNavigate } from "react-router-dom";

/**
 * CardServicesAdvisers component displays a clickable card with an image, title, and description.
 * Navigates to the specified link when clicked.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.imgSrc - Source URL for the card image.
 * @param {string} props.title - Title text displayed on the card.
 * @param {string} props.description - Description text displayed on the card.
 * @param {string} props.link - Path to navigate to when the card is clicked.
 * @param {string} [props.altText=""] - Alternative text for the image.
 * @returns {JSX.Element} The rendered CardServicesAdvisers component.
 */
const CardServicesAdvisers = ({
  imgSrc,
  title,
  description,
  link,
  altText = "",
}) => {
  const navigate = useNavigate();
  return (
    <div className={`Card-Services-Advisers`} onClick={() => navigate(link)}>
      <img loading="eager" fetchPriority="high" src={imgSrc} alt={altText} />
      <h3>{title}</h3>
      <div className="Content">{description}</div>
    </div>
  );
};

export default CardServicesAdvisers;
